import { useKeycloak } from "@react-keycloak/web";

export default function KeycloakRoles() {
  const { keycloak } = useKeycloak();
  return keycloak.tokenParsed?.realm_access?.roles;
}
